import isUndefined from 'lodash/isUndefined';
import isArray from 'lodash/isArray';
import each from 'lodash/each';
import React from 'react';
import ReactDOM from 'react-dom';
import Notification from 'notification-component';
import DOMUtils from '@spothero/utils/dom';
import StorageUtils from 'storage-utils';
import SHGlobals from 'sh-globals';

let containerTopPos = 0;
let index = 0;
let isWatchingScroll = false;

const body = DOMUtils.el('body');
const container = document.createElement('div');

const notificationRemoved = () => {
    if (!SHGlobals.isMobile && isUndefined(container.children) && isWatchingScroll) {
        window.removeEventListener('scroll', onDesktopScroll);

        isWatchingScroll = false;
    }
};

const onDesktopScroll = evt => {
    const windowTop = (!isUndefined(window.pageYOffset))
        ? window.pageYOffset
        : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    const containerTop = (windowTop > containerTopPos) ? windowTop : containerTopPos;

    container.style.top = containerTop;
};

const SHNotifcations = {
    /**
     * Adds a notification to the queue.
     * @static
     * @function add
     * @param {Object} data - The data to pass to the notification.
     * @param {String} data.message - The message to display inside the notification.
     * @param {String} [data.type] - The type of notification. ('success', 'error', 'warning')
     * @param {Integer} [data.duration=3000] - The time (in ms) to show the notification for.
     * @param {Boolean} [data.showClose=true] - Whether to show the close button.
     * @param {Boolean} [data.autoClose=true] - Whether to automatically close the notification after duration.
     * @param {Object} [data.cookie] - A cookie that, if present, only shows the notification once.
     * @param {String} data.cookie.name - The name of the cookie.
     * @param {Integer|Date} [data.cookie.expires] - The number of days (Integer) or the date (Date) that determines the lifetime of the cookie.
     * @param {Array.<Object>} [data.buttons] - Adds buttons to the notification.
     * @param {String} data.buttons.displayClass - The class to add to the button. ('Button' or 'Button-link')
     * @param {String} data.buttons.clickClass - A unique class to this notification which can differentiate this button from others.
     * @param {String} data.buttons.label - The button label.
     * @param {Function} data.buttons.callback - The method to call when the button is clicked.
     * @param {Array} [data.buttons.callbackParams] - Parameters to pass to the callback method.
     * @example
     * SHNotifications.add(
     *      {
     *          type: 'success'
     *          message: 'Success message here.'
     *          showClose: false,
     *          autoClose: false,
     *          duration: 2000,
     *          cookie: {
     *              name: 'nameOfCookie',
     *              expires: 1
     *          },
     *          buttons: [
     *              {
     *                  displayClass: 'Button',
     *                  clickClass: 'btn-label-1',
     *                  label: 'Label 1',
     *                  callback: cb,
     *                  callbackParams: [true, 'hello']
     *              },
     *              {
     *                  displayClass: 'Button-link',
     *                  clickClass: 'btn-label-2',
     *                  label: 'Label 2',
     *                  callback: cb2,
     *                  callbackParams: [this]
     *              }
     *          ]
     *      }
     * );
     * @returns {void}
     */
    add(data) {
        if (data.cookie) {
            if (StorageUtils.get(data.cookie.name, 'cookie')) {
                return;
            } else {
                let cookieExpires = null;

                if (!isUndefined(data.cookie.expires)) {
                    cookieExpires = data.cookie.expires;
                }

                StorageUtils.set(data.cookie.name, '1', 'cookie', cookieExpires);
            }
        }

        if (isUndefined(DOMUtils.el('.notification-container'))) {
            const nav = document.querySelector('.navbar');
            const isSecondary = DOMUtils.hasClass(nav, 'navbar-secondary');
            const containerCSSTop = (isSecondary) ? nav.offsetHeight : 0;

            containerTopPos = containerCSSTop;

            body.appendChild(container);
            DOMUtils.addClass(container, 'notification-container');
            container.style.top = `${containerCSSTop}px`;
            container.style.zIndex = (isSecondary) ? 13 : 18;
        }

        this._showNotifications(data);
    },

    _showNotifications(data) {
        const self = this;

        if (isArray(data)) {
            each(data, (notification, i) => {
                setTimeout(() => {
                    self._addNotification(notification, i);
                }, (i * 500));
            });
        } else {
            this._addNotification(data, index++);
        }
    },

    _addNotification(data, zIndex) {
        const {
            autoClose,
            showClose,
            type,
            message,
            duration
        } = data;
        const temp = document.createElement('div');

        ReactDOM.render(
            <Notification
                autoClose={autoClose}
                showClose={showClose}
                zIndex={zIndex}
                type={type}
                message={message}
                duration={duration}
                notificationRemoved={notificationRemoved}
            />,
            temp
        );

        container.insertBefore(temp, container.childNodes[0]);

        if (!SHGlobals.isMobile && !isWatchingScroll) {
            window.addEventListener('scroll', onDesktopScroll);
            onDesktopScroll();

            isWatchingScroll = true;
        }
    }
};

/**
 * Adds the ability to dispatch notifications from anywhere within the application. Wrap the objects to be dispatched in an array to show multiple notifications at once.
 * @module SHNotifications
 * @example
 * SHNotifications.add(
 *      {
 *          type: 'success'
 *          message: 'Success message here.'
 *      }
 * );
 */
module.exports = SHNotifcations;



// WEBPACK FOOTER //
// ./frontend/src/js/ui/sh-notifications.js